import SignUpContext from '@activities/auth/SignUpActivity/context/SignUpContext';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { ReactNode, useState } from 'react';
import { z } from 'zod';

interface Props {
    children?: ReactNode;
    kakaoId?: number;
    nickname?: string;
    appleId?: string;
    googleId?: string;
    email?: string;
    verificationToken?: string;
}

function SignUpContextProvider({
    children, kakaoId, nickname, appleId, googleId, email, verificationToken,
}:Props) {
    const isEmail = useIsEmailSignIn();
    const inputEmail = isEmail && (googleId || appleId) && z.string().email().safeParse(email).success
        ? email : undefined;
    const useVerified = useState<boolean>(false);
    const useValue = useState<string>('');
    const useMarketing = useState<boolean>(false);
    const useLocation = useState<boolean>(false);
    const useInputValue = useState<string>('');
    const useInputAuthCode = useState<string>('');
    const useSelectedTermCategories = useState<string[]>([]);
    return (
        <SignUpContext value={{
            useVerified,
            useValue,
            useMarketing,
            useLocation,
            useInputValue,
            useInputAuthCode,
            useSelectedTermCategories,
            kakaoId,
            nickname,
            appleId,
            googleId,
            inputEmail,
            verificationToken,
        }}>
            {children}
        </SignUpContext>
    );
}

export default SignUpContextProvider;
